<template>
<div>
  <div id="headstyle" v-on:mouseover="changeheader()" v-on:mouseout="changeheaders()">
    <div style="color:#FFF;top:0;display:flex;flex-direction:row;justify-content:space-between" >
      <!-- 导航栏 -->
      <div>
        <el-menu style="border:none;"
        :default-active="activeIndex2"
        class="menu"
        mode="horizontal"
        background-color="transparent !important"
        text-color="black"
          active-text-color="white">
          <el-menu-item v-if="transparent" style="margin:0 30px" index="0"><img style="object-fit: cover;;height:30px" :src="require(`@/image/导航透明.png`)" ></el-menu-item>
          <el-menu-item v-if="white" style="margin:0 30px" index="0"><img style="object-fit: cover;;height:30px;" :src="require(`@/image/logo.png`)" ></el-menu-item>
          <el-menu-item index="1"><router-link target="_blank" :to="{path:'/'}">首页</router-link></el-menu-item>
          <el-submenu index="2">
            <template slot="title">解决方案</template>
            <!-- <div class="menudiv"> -->
            <el-row :gutter="1" style="width:220px;padding:20px 30px;border-radius:0px 0px 4px 4px;margin-top:-10px;background-color:white;text-align: center;">
              <el-col :span="24"><el-menu-item class="menustyle"  index="2-1"><router-link target="_blank" :to="{path:'/solution',query:{name:'解决方案'}}">解决方案</router-link></el-menu-item></el-col>
              <el-col :span="24"><el-menu-item class="menustyle"  index="2-2"><router-link target="_blank" :to="{path:'/solution',query:{name:'法律科技'}}">法律科技</router-link></el-menu-item></el-col>
              <el-col :span="24"><el-menu-item class="menustyle"  index="2-3"><router-link target="_blank" :to="{path:'/solution',query:{name:'资产投资'}}">资产投资</router-link></el-menu-item></el-col>
              <el-col :span="24"><el-menu-item class="menustyles"  index="2-4"><router-link target="_blank" :to="{path:'/solution',query:{name:'资产处置'}}">资产处置</router-link></el-menu-item></el-col>
            </el-row>
          <!-- </div> -->
          </el-submenu>
          <el-submenu index="3">
            <template slot="title">业务区域</template>
            <el-row :gutter="1" style="width:220px;padding:20px 30px;border-radius:0px 0px 4px 4px;margin-top:-10px;background-color:white;text-align: left;">
              <el-col :span="24"><el-menu-item class="bigtitle" index="3-1"><router-link target="_blank" :to="{path:'/business'}">西北大区</router-link></el-menu-item></el-col>
              <el-col :span="24"><el-menu-item class="smalltitle" index="3-2"><router-link target="_blank" :to="{path:'/business'}">陕 | 新 | 甘 | 青 | 宁</router-link></el-menu-item></el-col>
              <el-col :span="24"><el-menu-item class="bigtitle" index="3-3"><router-link target="_blank" :to="{path:'/business'}">西南大区</router-link></el-menu-item></el-col>
              <el-col :span="24"><el-menu-item class="smalltitle" index="3-4"><router-link target="_blank" :to="{path:'/business'}">川 | 渝 | 贵 | 云 | 藏</router-link></el-menu-item></el-col>
              <el-col :span="24"><el-menu-item class="bigtitle" index="3-5"><router-link target="_blank" :to="{path:'/business'}">华北大区</router-link></el-menu-item></el-col>
              <el-col :span="24"><el-menu-item class="smalltitle" index="3-6"><router-link target="_blank" :to="{path:'/business'}">豫 | 鄂 | 湘</router-link></el-menu-item></el-col>
              <el-col :span="24"><el-menu-item class="bigtitle" index="3-7"><router-link target="_blank" :to="{path:'/business'}">华东大区</router-link></el-menu-item></el-col>
              <el-col :span="24"><el-menu-item class="smalltitle" index="3-8"><router-link target="_blank" :to="{path:'/business'}">京 | 津 | 冀 | 晋 | 蒙</router-link></el-menu-item></el-col>
              <el-col :span="24"><el-menu-item class="bigtitle" index="3-9"><router-link target="_blank" :to="{path:'/business'}">华南大区</router-link></el-menu-item></el-col>
              <el-col :span="24"><el-menu-item class="smalltitle" index="3-10"><router-link target="_blank" :to="{path:'/business'}">沪 | 苏 | 浙 | 皖 | 赣 | 鲁 | 闽</router-link></el-menu-item></el-col>
              <el-col :span="24"><el-menu-item class="bigtitle" index="3-11"><router-link target="_blank" :to="{path:'/business'}">华南大区</router-link></el-menu-item></el-col>
              <el-col :span="24"><el-menu-item class="smalltitle" index="3-12"><router-link target="_blank" :to="{path:'/business'}">粤 | 桂 | 琼</router-link></el-menu-item></el-col>
            </el-row>
          </el-submenu>
          <el-menu-item index="4"><router-link target="_blank" :to="{path:'/scene'}">场景应用</router-link></el-menu-item>
          <!-- <el-submenu index="4">
            <template slot="title">场景应用</template>
              <el-row :gutter="1" class="menudiv" >
                <el-col :span="24"><el-menu-item class="menustyle" index="4-1"><router-link target="_blank" :to="{path:'/scene'}">场景应用</router-link></el-menu-item></el-col>
                <el-col :span="24"><el-menu-item class="menustyle" index="4-2">资产端</el-menu-item></el-col>
                <el-col :span="24"><el-menu-item class="menustyle" index="4-3">司法端</el-menu-item></el-col>
                <el-col :span="24"><el-menu-item class="menustyle" index="4-4">处置端</el-menu-item></el-col>
              </el-row>
          </el-submenu> -->
          <!-- <el-submenu index="5">
            <template slot="title">新闻资讯</template>
              <el-row :gutter="1" class="menudiv" >
                <el-col :span="24"><el-menu-item class="menustyle" index="5-1"><router-link target="_blank" :to="{path:'/news',query:{name:'最新动态'}}">最新动态</router-link></el-menu-item></el-col>
                <el-col :span="24"><el-menu-item class="menustyle" index="5-2"><router-link target="_blank" :to="{path:'/news',query:{name:'媒体关注'}}">媒体关注</router-link></el-menu-item></el-col>
                <el-col :span="24"><el-menu-item class="menustyle" index="5-3"><router-link target="_blank" :to="{path:'/news',query:{name:'行业资讯'}}">行业资讯</router-link></el-menu-item></el-col>
              </el-row>
          </el-submenu> -->
          <el-submenu index="6">
            <template slot="title">关于微量数科</template>
              <el-row :gutter="1" class="menudiv" >
                <el-col :span="24"><el-menu-item class="menustyle" index="6-1"><router-link target="_blank" :to="{path:'/about',query:{name:'企业介绍'}}">企业介绍</router-link></el-menu-item></el-col>
                <el-col :span="24"><el-menu-item class="menustyle" index="6-2"><router-link target="_blank" :to="{path:'/about',query:{name:'企业文化'}}">企业文化</router-link></el-menu-item></el-col>
                <el-col :span="24"><el-menu-item class="menustyle" index="6-3"><router-link target="_blank" :to="{path:'/about',query:{name:'加入我们'}}">加入我们</router-link></el-menu-item></el-col>
                <el-col :span="24"><el-menu-item class="menustyle" index="6-4"><router-link target="_blank" :to="{path:'/about',query:{name:'联系我们'}}">联系我们</router-link></el-menu-item></el-col>
              </el-row>
          </el-submenu>
        </el-menu>
      </div>
      <!-- 联系电话 -->
      <div style="height:60px;text-align:right;height:60px;line-height:60px;padding:0 20px">
        <img style="height:16px;padding:0 10px;" :src="require(`@/image/座机2.png`)" v-if="transparent">
        <img style="height:16px;padding:0 10px;" :src="require(`@/image/座机.png`)" v-if="white">
        <span class="tranphone" v-if="transparent">0571-88028115 </span>
        <span class="whitephone" v-if="white">0571-88028115 </span>
      </div>
    </div>
  </div>
  <div>
  <div id="phonemenu" :class="navBarFixed == true ? 'navBarWrap' :''">
    <div style="display:flex;flex-direction:row;justify-content:space-between;align-items: center;margin:0 0.3rem;height: 1.2rem;">
      <div style="width:2.12rem;height:1.3rem;display: flex;align-items: center"><img style="width:100%;object-fit: cover;align-items: center;" :src="require(`@/image/微量数科.png`)" ></div>
      <div @click="moremenu()" v-if="moreshow"  style="width:0.54rem;height:1.3rem;display: flex;align-items: center"><img style="width:100%;align-items: center; object-fit: cover;" :src="require(`@/image/更多.png`)" ></div>
      <div @click="closemenu()" v-if="closeshow"  style="width:0.3rem;height:1.3rem;display: flex;align-items: center"><img style="width:100%;align-items: center;object-fit: cover;" :src="require(`@/image/关闭.png`)" ></div>
    </div>
    <div style="z-index:9999;display: flex;height: 100%;width: 100%;position: fixed;" v-if="menushow">
      <div style="height: 100%;;background-color: white;">
        <div v-on:mouseover="moreclick(1)" :class="menuindex == 1 ? 'menutitle':'menutitles'">首页</div>
          <div v-on:mouseover="moreclick(2)" :class="menuindex == 2 ? 'menutitle':'menutitles'">解决方案</div>
          <div v-on:mouseover="moreclick(3)" :class="menuindex == 3 ? 'menutitle':'menutitles'">业务区域</div>
          <div v-on:mouseover="moreclick(4)" :class="menuindex == 4 ? 'menutitle':'menutitles'">场景应用</div>
          <!-- <div v-on:mouseover="moreclick(5)" :class="menuindex == 5 ? 'menutitle':'menutitles'">新闻资讯</div> -->
          <div v-on:mouseover="moreclick(6)" :class="menuindex == 6 ? 'menutitle':'menutitles'">关于微量数科</div>
      </div>
      <div style="width:5rem;background-color:#F4F6FA;">
        <div v-if="menuindex ==1">
          <div class="contenttile" @click="close()"><router-link :to="{path:'/'}" target="_blank" replace>首页</router-link></div>
        </div>
        <div v-if="menuindex ==2">
          <div class="contenttile" @click="close()" ><router-link :to="{path:'/solution',query:{name:'解决方案'}}" target="_blank" replace>解决方案</router-link></div>
          <div class="contenttile" @click="close()" ><router-link :to="{path:'/solution',query:{name:'法律科技'}}" target="_blank" replace>法律科技</router-link></div>
          <div class="contenttile" @click="close()" ><router-link :to="{path:'/solution',query:{name:'资产处置'}}" target="_blank" replace>资产处置</router-link></div>
          <div class="contenttile" @click="close()" ><router-link :to="{path:'/solution',query:{name:'资产投资'}}" target="_blank" replace>资产投资</router-link></div>
        </div>
        <div v-if="menuindex ==3">
          <div class="regionstyle" @click="close()"><router-link :to="{path:'/business'}" target="_blank" replace>西北大区</router-link></div>
          <div class="regionstyles" @click="close()"><router-link :to="{path:'/business'}" target="_blank" replace>陕 | 新 | 甘 | 青 | 宁</router-link></div>
          <div class="regionstyle" @click="close()"><router-link :to="{path:'/business'}" target="_blank" replace>西南大区</router-link></div>
          <div class="regionstyles" @click="close()"><router-link :to="{path:'/business'}" target="_blank" replace>川 | 渝 | 贵 | 云 | 藏</router-link></div>
          <div class="regionstyle" @click="close()"><router-link :to="{path:'/business'}" target="_blank" replace>华北大区</router-link></div>
          <div class="regionstyles" @click="close()"><router-link :to="{path:'/business'}" target="_blank" replace>豫 | 鄂 | 湘</router-link></div>
          <div class="regionstyle" @click="close()"><router-link :to="{path:'/business'}" target="_blank" replace>华东大区</router-link></div>
          <div class="regionstyles" @click="close()"><router-link :to="{path:'/business'}" target="_blank" replace>京 | 津 | 冀 | 晋 | 蒙</router-link></div>
          <div class="regionstyle" @click="close()"><router-link :to="{path:'/business'}" target="_blank" replace>华南大区</router-link></div>
          <div class="regionstyles" @click="close()"><router-link :to="{path:'/business'}" target="_blank" replace>沪 | 苏 | 浙 | 皖 | 赣 | 鲁 | 闽</router-link></div>
          <div class="regionstyle" @click="close()"><router-link :to="{path:'/business'}" target="_blank" replace>华南大区</router-link></div>
          <div class="regionstyles" @click="close()"><router-link :to="{path:'/business'}" target="_blank" replace>粤 | 桂 | 琼</router-link></div>
        </div>
        <div v-if="menuindex ==4">
          <div class="contenttile" @click="close()"><router-link :to="{path:'/scene'}" target="_blank" replace>场景应用</router-link></div>
        </div>
        <!-- <div v-if="menuindex ==5">
          <div class="contenttile" @click="close()">最新动态</div>
          <div class="contenttile" @click="close()">媒体关注</div>
          <div class="contenttile" @click="close()">行业资讯</div>
          <div class="contenttile" @click="close()">产品答疑</div>
        </div> -->
        <div v-if="menuindex ==6">
          <div class="contenttile"  @click="close()"><router-link :to="{path:'/about',query:{name:'企业介绍'}}" target="_blank" replace>企业介绍</router-link></div>
          <div class="contenttile" @click="close()"><router-link :to="{path:'/about',query:{name:'企业文化'}}" target="_blank" replace>企业文化</router-link></div>
          <div class="contenttile">加入我们</div>
          <div class="contenttile">联系我们</div>
        </div>
      </div>
      </div>
    </div>
  </div></div>
</template>

<script>
export default {
  data(){
    return{
      transparent:true,
      navBarFixed :false,
      white:false,
      // activeIndex2: '2-1',
      menuindex: '1',
      menushow:false,
      moreshow:true,
      closeshow:false,
    }
  },
  props: {
    activeIndex2: {
      type: String,
      default: "",
    },
  },
  mounted () {
    // 事件监听滚动条
    window.addEventListener('scroll', this.watchScroll)
  },
  created(){
  },
  methods:{
    handleSelect() {
      // this.$emit("handleSelect");
    },
    business(){
      const routeData = this.$router.resolve({ path: '/business'})
      window.open(routeData.href, '_blank')
    },
    close(){
      document.documentElement.scrollTop = 0;
      this.menushow = false
      this.moreshow = true
      this.closeshow = false
    },
    watchScroll () {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      //  当滚动超过 50 时，实现吸顶效果
      if (scrollTop > 0.1) {
        this.navBarFixed = true
      } else {
        this.navBarFixed = false
      }
    },
    moremenu(){
      this.menushow = true
      this.moreshow = false
      this.closeshow = true
    },
    closemenu(){
      this.menushow = false
      this.moreshow = true
      this.closeshow = false
    },
    moreclick(e){
      this.menuindex = e
    },
    changeheader(){
        this.transparent = false
        this.white = true
    },
    changeheaders(){
      this.transparent = true
      this.white = false
    },
  }
}
</script>

<style lang="scss">
  @media screen and (min-width: 750px) {
    html{font-size:calc(100vw * 14 / 1920);}
    .el-menu-item.is-active {color:white !important;background-color:transparent!important;border-bottom-color:#1890ff !important}
    ::deep .el-submenu {color:white !important;background-color:transparent!important;border-bottom-color:#1C6EDD}
    .el-submenu__title,.el-menu-item{color:white !important;background-color:transparent!important;border-bottom-color:#1C6EDD;font-size:1rem !important;}
    .el-submenu__title:focus,
    .el-submenu__title:hover {
      outline: 0;
      color:black !important;
      background-color:white !important;
      border-bottom-color:#1C6EDD !important;
      .el-menu-item.is-active,.el-menu-item{color:black!important;background-color:white!important;border-bottom-color:white !important}
    }
    .el-menu--horizontal>.el-submenu.is-active .el-submenu__title{color:white!important;background-color:transparent!important;border-bottom-color:#1C6EDD !important}
    #headstyle{z-index:999;position: absolute;top: 0;width:100%;background-color: transparent !important;}
    #phonemenu{display: none;}
    #headstyle:hover{background-color: white !important;
       .el-menu-item,.el-submenu__title,.el-menu-item.is-active{color:black!important;background-color:white!important;border-bottom-color:#1C6EDD}
       ::deep .el-submenu {color:black !important;background-color:white!important;border-bottom-color:#1C6EDD}
    }
    .menustyle{display:inline-block;color:#1C1C1C !important;cursor:pointer;font-size: 0.78rem !important;}
    .menustyles{display:inline-block;color:#1C1C1C;cursor:pointer;font-size: 0.78rem !important;}
  
    .bigtitle{font-size:1rem;display:inline-block;color:#1C1C1C !important;cursor:pointer;}
    .smalltitle{font-size:0.78rem !important;color:#ABACAC !important;margin-top:-10px;}
    
    .tranphone{width:6rem;height: 11px;font-size: 1rem;font-weight: 400;color: white;}
    .whitephone{width:6rem;height: 11px;font-size: 1rem;font-weight: 400;color: black;}
    .menudiv{width:200px;padding:20px 10px;border-radius:0px 0px 4px 4px;margin-top:-10px;background-color:white;text-align: center;}
    .router-link-active {text-decoration: none;color: #1C1C1C;}
    a{text-decoration: none;color: #1C1C1C;}
  }
  @media screen  and (max-width: 750px){
    html{font-size:calc(100vw / 750 * 100);}
    #headstyle{display: none;}
    .navBarWrap {position:fixed;top:0;z-index:1999;}
    #phonemenu{z-index:1000;background-color: white;height: 1.2rem;width: 100vw;}
    .menutitles{width:2.5rem;height: 1.03rem;line-height:1.03rem;font-size: 0.24rem;background-color: white;text-align: center;}
    .menutitle{width:2.5rem;height: 1.03rem;line-height:1.03rem;font-size: 0.24rem;;background-color: #378BFF;color: white;text-align: center;}
    .contenttile{width:2.5rem;height: 1.03rem;line-height:1.03rem;font-size: 0.24rem;text-align: center;}
    .regionstyle{margin-left:0.58rem;height:0.9rem;line-height:0.9rem;font-size: 0.24rem;}
    .regionstyles{margin-left:0.58rem;height:0.9rem;line-height:0.5rem;font-size: 0.24rem;}
    .router-link-active {text-decoration: none;color: #1C1C1C;}
    a{text-decoration: none;color: #1C1C1C;}
  }
</style>